module.exports = __webpack_public_path__ + "media/images/ajax-loader-56d4c7ce.gif";